<template>
  <div class="concept">
    <div id="head-page" class="meubles parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/meubles-03.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/meubles-01.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/meubles-02.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">


        <div class="small-12 medium-8 medium-offset-2 cell">

          <title-page attrpage="FAQ" baseline="Trouvez les réponses à vos questions sur cette page">Foire Aux Questions</title-page>
          <ul class="accordion" data-accordion>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(0) !== -1}]" data-accordion-item @click="e => toggle(0)">
              <a  class="accordion-title">Qu’est-ce que Globulo Quest ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(0) !== -1">
                <p>Globulo Quest est une solution digitale qui prend la forme d’un site web et de jeux interactifs.  Il a pour but d’accompagner les enfants atteints de leucémie dans leur traitement et leur quotidien. L’objectif est d’expliquer aux enfants à partir de 7 ans quels soins ils vont recevoir, comment ils se déroulent et pourquoi ils sont nécessaires, afin de les rassurer et de les rendre acteurs de leur parcours de soins. Cette application est également destinée à les distraire et à leur permettre de garder le contact avec leurs proches pendant l’hospitalisation. Un autre but est de centraliser les ressources disponibles pour donner de l’information de qualité et facilement accessible aux parents. Enfin, le programme Globulo Quest a aussi été pensé pour créer une vraie relation avec les soignants qui le souhaitent et la conserver à distance lors du retour au domicile.</p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(1) !== -1}]" data-accordion-item @click="e => toggle(1)">
              <a  class="accordion-title">Qui peut se servir de Globulo Quest et créer des comptes ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(1) !== -1">
                <p>
                  Globulo Quest est un programme créé bénévolement par la Fédération Leucémie Espoir qui est accessible gratuitement à tous depuis le site <a href="http://www.globulo-quest.org/" title="globulo Quest" >www.globulo-quest.org.</a></br>
                  Il a été conçu pour que les parents d’un enfant atteint de leucémie soient les administrateurs de la solution pour leur enfant et ses proches.</br>
                  Le parent se crée un compte et crée un sous-compte à son enfant auquel il est rattaché au sein de la communauté personnelle de l’enfant. Le parent est responsable de la création des sous-comptes des proches : famille, amis, école etc… Les soignants peuvent également se créer un compte individuel mais doivent demander l’autorisation au parent administrateur pour faire partie de la communauté de l’enfant malade.
                </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(2) !== -1}]" data-accordion-item @click="e => toggle(2)">
              <a  class="accordion-title">Comment créer un compte Parent, un compte Enfant, un compte Proche, un compte Professionnel de Santé ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(2) !== -1">
                <h6>Compte Parent ou Professionnel de Santé</h6>
                <p>
                  Pour que le parent administrateur ou le soignant se crée un compte, il faut cliquer sur l’onglet Créer mon Compte Globulo sur le menu principal de la page d’accueil.
                  Remplir le formulaire avec les champs requis en choisissant un mot de passe.
                  Un email de confirmation sera envoyé (éventuellement classé dans le courrier indésirable, à vérifier). Si cet email n’est pas reçu, il est possible de contacter l’Equipe Globulo Quest et lui faire part de ce problème.
                </p>

                <h6>Sous-compte Enfant ou Proche</h6>
                <p>
                  Seul le parent peut créer le compte de l’enfant malade.
                  Le parent doit d’abord Se Connecter à son propre compte Globulo Quest. Avec son email et son mot de passe. Sa première démarche pour avoir accès à son carnet de bord est de créer le compte enfant en remplissant les champs du formulaire qui s’affiche à la connexion.
                  Le parent peut renseigner un pseudonyme/identifiant choisi par son enfant, éventuellement différent de son prénom. Il doit également créer un mot de passe et sélectionner le contenu auquel l’enfant ou le proche peut avoir accès selon son âge ou des critères propres à la famille (ami plus ou moins proche etc…)
                  La création par le parent administrateur d’un sous-compte proche rattache celui-ci à la communauté de l’enfant.
                  Un email de confirmation sera envoyé.
                </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(3) !== -1}]" data-accordion-item @click="e => toggle(3)">
              <a  class="accordion-title">A quelles informations du programme ont accès ces différents types d’utilisateurs ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(3) !== -1">

                <h6>Parent ou Soignant</h6>
                <p>accès aux mêmes contenus mais seuls les parents peuvent créer le sous-compte enfant ou proche et rattacher le sous-compte enfant à un soignant ou un proche (création de la communauté).
                  <ul>
                    <li>Toutes les pages fixes</li>
                    <li>Les mini-jeux de l’enfant auquel il est rattaché : possibilité d’y jouer (pas de partage de scores)</li>
                    <li>Le jeu Fil Rouge avec possibilité d’y jouer en tant que membre de la communauté de l’enfant et de partager des scores.</li>
                    <li>La bibliothèque</li>
                    <li>Le rapport d’humeur est accessible par défaut aux parents et peut être rendu accessible aux soignants au libre choix des parents et de l’enfant</li>
                  </ul>
                </p>

                <h6>Proche</h6>
                <p>
                  <ul>
                    <li>Toutes les pages fixes</li>
                    <li>Le jeu Fil Rouge avec possibilité d’y jouer en tant que membre de la communauté de l’enfant et de partager des scores.</li>
                    <li>La bibliothèque, pas d’accès par défaut mais au libre choix du parent, selon l’âge du proche ou d’autres critères définis par eux.</li>
                    <li>Exclusion : l’espace mini-jeux de l’enfant auquel il est rattaché</li>
                    <li>Le rapport d’humeur : pas d’accès par défaut, au libre choix des parents et de l’enfant selon l’âge du proche ou d’autres critères définis par eux.</li>
                  </ul>
                </p>

              <h6>Enfant</h6>
              <p>
                <ul>
                  <li>Toutes les pages fixes</li>
                  <li>Les mini-jeux avec possibilité d’y jouer</li>
                  <li>Le jeu Fil Rouge avec possibilité d’y jouer et de partager des scores avec sa communauté.</li>
                  <li>Exclusion : la bibliothèque, le rapport d’humeur</li>
                </ul>
              </p>

              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(4) !== -1}]" data-accordion-item @click="e => toggle(4)" id="askCalendar">
              <a  class="accordion-title">Qui peut jouer au jeu Fil Rouge ? </a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(4) !== -1">
                <p>
                  Le jeu Fil Rouge est le jeu qui va permettre de créer du lien entre l’enfant et ses soignants et lui donner la possibilité de garder le contact avec sa famille et ses proches, même à distance. Ainsi, le Jeu Fil Rouge sera accessible à toutes les personnes ayant un compte Globulo Quest rattaché à celui de l’enfant formant sa communauté : parent, soignant, proche et l’enfant lui-même.</br></br>
                  La communauté de l’enfant sera créée autour du jeu Fil Rouge en permettant aux proches de comparer leurs scores avec lui.
                </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(5) !== -1}]" data-accordion-item @click="e => toggle(5)" >
              <a  class="accordion-title">Qui peut jouer aux mini-jeux ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(5) !== -1">
                 <p>
                  Les Mini-Jeux seront accessibles à l’enfant ainsi qu’aux parents et aux soignants. </br></br>
                  Ces jeux sont créés afin d’expliquer de manière simple et ludique les prochains soins, traitements ou interventions que l’enfant va recevoir pour le rassurer et l’aider à appréhender ces moments avec les professionnels de santé.</br></br>
                  Chaque enfant suit un plan de traitement personnalisé défini par son équipe soignante. De même, chaque enfant aura accès uniquement aux Mini-Jeux Globulo Quest adaptés à sa situation et son parcours de soin. Ceci grâce au fait que les parents débloquent les Mini-Jeux en ajoutant les Rendez-Vous correspondants aux soins dans le Calendrier de l’enfant. Veuillez-vous reporter à la question <a class="js-scrollTo" title="Comment ajouter un rendez-vous au calendrier" @click="e => toggle(6)">« Comment ajouter un rendez-vous au calendrier »</a> pour savoir comment faire.</br></br>
                  L’enfant sera notifié de la disponibilité du Mini-Jeu sur son Carnet de Bord. Le parent et le soignant seront également notifiés sur leur Carnet de Bord et par email s’ils le souhaitent pour inciter l’enfant à jouer au mini-jeu. La notification donnera aussi accès aux parents et aux soignants à des ressources documentaires de la Bibliothèque en lien avec le Rendez-Vous.
                </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(6) !== -1}]" data-accordion-item @click="e => toggle(6)" >
              <a  class="accordion-title">Comment ajouter un rendez-vous au calendrier ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(6) !== -1">
                 <p>
                  En tant que parent, vous aurez accès au Calendrier de votre enfant depuis votre Carnet de Bord. Pour créer un Rendez-Vous, cliquez sur le lien « Ajouter/Modifier une date ». Sur la page « Enregistrez un rendez-vous » qui s’affiche, vous serez amené à remplir un court formulaire pour renseigner le type de rendez-vous ainsi que la date et l’heure du rendez-vous.</br></br>
                  Une fois le rendez-vous validé, vous recevrez un email de confirmation et il sera visible sur une échelle de temps de la page Agenda et Notifications.
                 </p>
              </div>
            </li>


            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(7) !== -1}]" data-accordion-item @click="e => toggle(7)" >
              <a  class="accordion-title">Qui peut voir les résultats du sondage d’humeur ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(7) !== -1">
                 <p>
                  Chaque fois que l’enfant se connecte sur la plateforme Globulo Quest et une fois par jour, il sera invité à renseigner son humeur/moral (4 résultats possibles). </br></br>
                  Les parents seront immédiatement tenus au courant du résultat du sondage par email si le moral déclaré est mauvais. L’évolution de l’humeur de l’enfant dans le temps sera accessible sur le Carnet de Bord des parents. </br></br>
                  Si un compte soignant est relié à celui de l’enfant, le soignant aura aussi accès à l’évolution de l’humeur de l’enfant.
                 </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(8) !== -1}]" data-accordion-item @click="e => toggle(8)" >
              <a  class="accordion-title">Comment modifier les informations concernant mon compte ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(8) !== -1">
                 <p>
                  Sur votre Carnet de Bord, cliquez sur le lien « Gérer mon profil et mes préférences. Vous aurez alors accès aux informations renseignées lors de la création de votre compte et pourrez les éditer. Vous aurez également la possibilité de gérer les types de notifications que vous souhaitez recevoir et le canal de diffusion (email ou SMS, option à venir).
                 </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(9) !== -1}]" data-accordion-item @click="e => toggle(9)" >
              <a  class="accordion-title">Comment modifier les informations concernant le compte de mon enfant ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(9) !== -1">
                 <p>
                    Sur votre Carnet de Bord, cliquez sur « Gérer le profil de –Prénom de votre enfant- ». Vous aurez alors accès aux informations renseignées lors de la création du compte de votre enfant et pourrez les éditer.
                 </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(13) !== -1}]" data-accordion-item @click="e => toggle(13)" >
              <a  class="accordion-title">Qui peut être rattaché au compte d’un enfant et comment procéder ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(13) !== -1">

                  <p>Par défaut le compte Parent qui crée le compte Enfant est rattaché à celui-ci.</p>

                  <h6>Proches membres de la Communauté de l’Enfant : <em>2 possibilités</em></h6>

                  <p><strong>1/ Création du compte proche par le parent</strong>
                  <br>
                  Le compte Parent peut créer un compte Proche depuis Carnet de bord Parent > Gérer les Proches > Ajouter un proche
                  <br>
                  <br>
                  Le parent renseigne alors un formulaire et choisit un pseudo et un mot de passe au proche qu’il lui communiquera. Il n’est pas nécessaire que le proche créé ainsi ait une adresse email.
                  Il est donc possible pour le parent de créer un compte proche à une personne ne disposant pas d’adresse email (cas d’un jeune ami par exemple).
                  <br>
                  <br>
                  Le proche se connectera à la plateforme Globulo Quest en saisissant son pseudo et son mot de passe et fera partie de la Communauté de l’enfant.
                  </p>

                  <p><strong>2/ Invitation du proche par email</strong>
                  <br>
                  Le compte Parent peut aussi envoyer une invitation email à un proche depuis Carnet de bord > Gérer les proches > Envoyer une demande.
                  <br>
                  <br>
                  Le proche recevra un email avec un lien l’invitant à se créer lui-même un compte sur Globulo Quest grâce à un formulaire. Il créera lui-même son mot de passe.
                  Attention de bien créer un compte avec l’adresse email sur laquelle l’invitation a été reçue pour que le compte Proche soit directement rattaché au compte Enfant.
                  <br>
                  <br>
                  Le proche se connectera à la plateforme Globulo Quest en saisissant son adresse email et son mot de passe et fera partie de la Communauté de l’enfant.
                 </p>

                  <h6>Team de Soignants : <em>1 seule possibilité, l’invitation email par le parent</em></h6>
                  <p>
                  Le compte Parent peut envoyer une invitation email à un soignant depuis Carnet de bord > Gérer les soignants > Envoyer une demande.
                  <br>
                  <br>
                  Le soignant recevra un email avec un lien l’invitant à se créer lui-même un compte sur Globulo Quest grâce à un formulaire spécial pour l’équipe soignante. Il renseignera sa profession (pour afficher un avatar plus parlant pour l’enfant) et créera lui-même son mot de passe.
                  Attention de bien créer un compte soignant avec l’adresse email sur laquelle l’invitation a été reçue pour que le compte Proche soit directement rattaché au compte Enfant.
                  <br>
                  <br>
                  Le soignant se connectera à la plateforme Globulo Quest en saisissant son adresse email et son mot de passe et fera partie de la Team de Soignants de l’enfant.
                  </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(10) !== -1}]" data-accordion-item @click="e => toggle(10)" >
              <a  class="accordion-title">Comment personnaliser mon avatar ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(10) !== -1">
                 <p>
                    Sur votre Carnet de Bord, en haut à droite de votre avatar cliquez sur l’icône du petit crayon. Puis cliquez sur les différentes flèches de part et d’autre de votre avatar pour faire défiler les options disponibles. Il existe 7 différents items qu’il est possible de modifier : la couleur de l’avatar, le chapeau, les lunettes, les yeux, la moustache, le sourire et le nœud papillon
                 </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(11) !== -1}]" data-accordion-item @click="e => toggle(11)" >
              <a  class="accordion-title">Où vont mes données ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(11) !== -1">
                 <p>
                    Les données concernant votre compte, celle de votre enfant ou des proches restent uniquement dans la plateforme de Globulo Quest. Aucune utilisation par d'autres services ne sera faite sans votre accord au préalable.
                 </p>
              </div>
            </li>

            <li :class="['accordion-item', {'is-active': openFAQ.indexOf(12) !== -1}]" data-accordion-item @click="e => toggle(12)" >
              <a  class="accordion-title">Comment puis-je me désabonner de ce programme ?</a>
              <div class="accordion-content" data-tab-content v-if="openFAQ.indexOf(12) !== -1">
                 <p>
                    Sur votre Carnet de Bord, cliquez sur « Gérer mon profil et mes préférences ». Cliquez sur le lien en rouge « Supprimer mon compte » qui se trouve sur la droite.
                 </p>
              </div>
            </li>


          </ul>

          <p>Vous ne trouvez pas la réponse à votre question ? </br> Ecrivez-nous à contact@globulo-quest.org ou via notre <router-link :to="{ name: 'contact_us' }" title="Contact Globulo Quest">formulaire de contact</router-link>.</p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import TitlePage from '@/components/TitlePage'


  export default {
    components: { TitlePage },
    data() {
      return {
        openFAQ: []
      }
    },
    methods: {
      toggle (faq) {
        let index = this.openFAQ.indexOf(faq)
        if(index !== -1) {
          Vue.delete(this.openFAQ, index)
        } else {
          this.openFAQ.push(faq)
        }
      }
    }
  }
</script>
